<template>
    <!-- P11: the treatments due today on a program. -->
    <div
        v-if="treatments.length"
        class="bg-brand-yellow/10 text-brand-yellow flex items-start gap-2 rounded-lg p-3 text-sm"
    >
        <BeakerIcon class="mt-0.5 h-4 w-4 shrink-0" />
        <div class="space-y-0.5">
            <div class="font-semibold">{{ $t('protocol.treatment-today') }}</div>
            <div>{{ treatmentLabels(treatments) }}</div>
        </div>
    </div>
</template>

<script setup>
import { BeakerIcon } from '@heroicons/vue/24/outline'
import { treatmentLabels } from '@/lib/programs/treatments'

defineProps({
    treatments: { type: Array, default: () => [] },
})
</script>
